
import api from "@/services/api"
import { AssignmentOperation, RecordUserAssignment } from "@/types/assignment"
import { UserTime } from "@/types/timeManagement"

class ApiAssignments {
	private get axios () { return api.getAxios() }

	public async recordAssignments (recordId: string): Promise<RecordUserAssignment[]> {
		return (await this.axios.get(`/timeManagement/assignmentsForRecord/${recordId}`)).data
	}

	public async assignmentSet (recordId: string, userId: string, fieldId: string, date: string, hours: number, operation: AssignmentOperation = AssignmentOperation.Set): Promise<RecordUserAssignment[]> {
		return (await this.axios.post("/timeManagement/assignedHoursSet", {
			recordId,
			userId,
			fieldId,
			date,
			hours,
			operation
		})).data
	}

	public async assignmentRemove (recordId: string, userId: string, fieldId: string, date: string): Promise<RecordUserAssignment[]> {
		return (await this.axios.post("/timeManagement/assignedHoursClear", {
			recordId,
			userId,
			fieldId,
			date
		})).data
	}

	public async userTimeForDate (userId: string, date: string): Promise<UserTime> {
		return (await this.axios.get(`/timeManagement/userTimeForDate/${userId}`, {
			params: {
				date
			}
		})).data
	}
}

const apiAssignment = new ApiAssignments()
export default apiAssignment
